import { n as b } from "./Logger-CmiOOsKC.js";
import { t as z } from "./tracebehavior-5_qSKjs6.js";
import { Matrix as g, Vector3 as k } from "@babylonjs/core/Maths/math.vector.js";
import { MeshBuilder as P } from "@babylonjs/core/Meshes/meshBuilder.js";
import { StandardMaterial as C } from "@babylonjs/core/Materials/standardMaterial.js";
import { Color3 as I } from "@babylonjs/core/Maths/math.color.js";
var O = "__collider", F = "__selection", v = 0.05, W = class p extends z {
  static behaviorType = "BoxCollider";
  _pickerMesh = null;
  getPickerMesh() {
    return this._pickerMesh;
  }
  onAttach(t) {
    if (!this._resolved.size) {
      const i = this._getModelBounds(t), s = i?.size ?? [
        1,
        1,
        1
      ], e = this._resolved.center ?? i?.center ?? [
        0,
        0,
        0
      ];
      this.commit({
        size: s,
        center: e
      });
      return;
    }
    this._createPickerMesh(t);
  }
  onDetach() {
    this._disposePickerMesh();
  }
  async applyCommit(t) {
    this.attachedNode && (this._disposePickerMesh(), this._createPickerMesh(this.attachedNode), this.sceneObject.traceScene.refreshMeshPickability?.(this.sceneObject));
  }
  setDebugVisible(t) {
    if (this._pickerMesh && (this._pickerMesh.visibility = t ? 0.3 : 0, t && !this._pickerMesh.material)) {
      const i = new C(`${this.sceneObject.name}_collider_debug_mat`, this.sceneObject.babylonScene);
      i.diffuseColor = new I(0, 1, 0), i.wireframe = !0, this._pickerMesh.material = i;
    }
  }
  _createPickerMesh(t) {
    const i = this._resolved, s = i.size ?? [
      1,
      1,
      1
    ], e = i.center ?? [
      0,
      0,
      0
    ];
    b.debug(`[BoxCollider] Creating picker mesh for "${this.sceneObject.name}": size=(${s[0]}, ${s[1]}, ${s[2]}), center=(${e[0]}, ${e[1]}, ${e[2]})`), this._pickerMesh = P.CreateBox(`${this.sceneObject.name}${O}`, {
      width: s[0],
      height: s[1],
      depth: s[2]
    }, this.sceneObject.babylonScene), this._pickerMesh.position.set(e[0], e[1], e[2]), this._pickerMesh.parent = t, this._pickerMesh.visibility = 0, this._pickerMesh.isPickable = !0, b.debug(`[BoxCollider] Picker mesh created: "${this._pickerMesh.name}", isPickable=${this._pickerMesh.isPickable}`);
  }
  _getModelBounds(t) {
    const i = t.getChildMeshes(!1), s = p._boundsOf(t, i.filter((r) => !r.name.endsWith("__collider") && !r.name.endsWith("__selection")));
    if (s) return s;
    const e = p._boundsOf(t, i.filter((r) => r.name.endsWith("__selection") && r.isEnabled(!1)));
    return e ? {
      size: [
        e.size[0],
        e.size[1],
        Math.max(e.size[2], v)
      ],
      center: e.center
    } : null;
  }
  static _boundsOf(t, i) {
    if (i.length === 0) return null;
    t.computeWorldMatrix(!0);
    const s = t.getWorldMatrix(), e = s.determinant() !== 0 ? g.Invert(s) : null;
    let r = 1 / 0, a = 1 / 0, h = 1 / 0, l = -1 / 0, m = -1 / 0, d = -1 / 0;
    const n = new k();
    for (const M of i) {
      M.computeWorldMatrix(!0);
      const x = M.getBoundingInfo().boundingBox, o = x.minimum, c = x.maximum;
      if (!(o.equalsToFloats(0, 0, 0) && c.equalsToFloats(0, 0, 0)))
        if (e) {
          const y = M.getWorldMatrix().multiply(e);
          for (let _ = 0; _ <= 1; _++) for (let f = 0; f <= 1; f++) for (let u = 0; u <= 1; u++)
            n.set(_ === 0 ? o.x : c.x, f === 0 ? o.y : c.y, u === 0 ? o.z : c.z), k.TransformCoordinatesToRef(n, y, n), r = Math.min(r, n.x), a = Math.min(a, n.y), h = Math.min(h, n.z), l = Math.max(l, n.x), m = Math.max(m, n.y), d = Math.max(d, n.z);
        } else
          r = Math.min(r, o.x), a = Math.min(a, o.y), h = Math.min(h, o.z), l = Math.max(l, c.x), m = Math.max(m, c.y), d = Math.max(d, c.z);
    }
    return isFinite(r) ? {
      size: [
        l - r,
        m - a,
        d - h
      ],
      center: [
        (r + l) / 2,
        (a + m) / 2,
        (h + d) / 2
      ]
    } : null;
  }
  _disposePickerMesh() {
    this._pickerMesh && (this._pickerMesh.dispose(), this._pickerMesh = null);
  }
};
export {
  O as n,
  F as r,
  W as t
};

//# sourceMappingURL=boxcollider-DfK5pGI3.js.map